<script setup lang="ts">
import { PublicSellerCertificatesQuery } from '@gql/PublicSellerCertificatesQuery'

const t2 = useT2({
  Certificates: 'Sertifikatai',
})

const { seller, sellerId } = useSeller('server')

const { ui: icons } = useApolloWrap2<gen.PublicSellerCertificatesQuery, gen.PublicSellerCertificatesQueryVariables>(PublicSellerCertificatesQuery)({
  vars() {
    const id = sellerId.value
    return id ? { sellerId: id } : undefined
  },
  ui: (i) => helpers.arr(i?.publicSellerCertificates),
})

// https://www.intimissimi.com/lt/product-guide-textiles.html
// https://www.meandem.com/fabric-lab
</script>

<template>
  <AppMenu :title="t2('Certificates')">
    <template #content>
      <DocumentUi :document-id="seller?.doc?.certificate?._id" />
    </template>
    <InfoCare :icons class="d_ml1 d_mr1 m_ml04 m_mr04" />
  </AppMenu>
</template>
